module.exports = __webpack_public_path__ + "img/tv-ad-default.3b7997cb.png";